<template>
  <AppModal :id="id" :size="size">
    <template v-slot:title>
      <h3 class="text-center mb-5">{{ $t($getConst.pages.pageUserDetails.notification_data) }} </h3>
    </template>
    <template v-slot:content>
      <pre>{{ JSON.stringify(notification.data, null, 2) }}</pre>
    </template>
    <template v-slot:button>
      <AppConfirmButtons :firstButton="false"
        @onCancel="close"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppModal from "../../components/common/modals/AppModal";
  import AppConfirmButtons from "../../components/common/utils/AppConfirmButtons";

  export default {
    name: "ShowNotificationDataModal",
    components: {AppConfirmButtons, AppModal},
    props: {
      id: String,
      notification: null,
      size: String
    },
    methods: {
      close() {
        this.$bvModal.hide(this.id);
        this.$emit('onCancel');
      },
    }
  }
</script>

<style scoped>

</style>
